import { getDefaultBasemapKey } from "common/basemaps";

const INITIAL_STATE = {
  basemapKey: getDefaultBasemapKey(),
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_DISPLAY_BASEMAP_KEY":
      return {
        ...state,
        basemapKey: action.payload.basemapKey,
      };
    default:
      return { ...state };
  }
};

export default reducer;
